module.exports = __webpack_public_path__ + "static/media/logo-web.65d3cde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/cyber-monday/logo-web.png
// module id = 1459
// module chunks = 0